<template>
    <div class="form-group row">
        <label class="col-md-2 col-form-label text-capitalize">{{ label }}</label>
        <div class="col-md-2 d-flex">
            <button
              type="button"
              :disabled="disabled"
              class="col mr-2 btn"
              :class="classOK"
              @click="setValue(true)"
            >OK</button>
            <button
              type="button"
              :disabled="disabled"
              class="col btn"
              :class="classNOK"
              @click="setValue(false)"
            >NOK</button>
        </div>
        <div v-if="showComment" class="col-md-8">
            <input
                    class="form-control"
                    :disabled="disabled"
                    :id="field + '-comment-input'"
                    placeholder="Comment"
                    required
                    type="text"
                    v-model="comment"
            >
        </div>
    </div>
</template>

<script>
export default {
  name: 'EvaluationColumnBoolean',
  props: {
    alwaysComment: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    field: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      comment: '',
      value: null,
    };
  },
  methods: {
    setValue(value) {
      this.value = value;
      this.$emit('update-value', { field: this.field, value: this.value });
    },
  },
  computed: {
    classNOK() {
      return this.value === false ? 'btn-danger' : 'btn-outline-danger';
    },
    classOK() {
      return this.value === true ? 'btn-success' : 'btn-outline-success';
    },
    showComment() {
      if (this.alwaysComment === null) return false;
      if (this.alwaysComment || this.value === false) return true;
      return false;
    },
  },
};
</script>

<style scoped>

</style>
